import WebFont from "webfontloader";

export default function() {
  WebFont.load({
    google: {
      families: ["Lato:300,400,700"],
    },
  });
}



// WEBPACK FOOTER //
// ./src/config/fonts.js